import React, { useState } from "react";
import { Sidebar } from "./Sidebar";
import { Topbar } from "./Topbar";
import { MobileNav } from "./MobileNav";

export function AppShell({ children }) {
  const [mobileNavOpen, setMobileNavOpen] = useState(false);

  return (
    <div className="flex h-screen w-full overflow-hidden bg-background print:h-auto print:overflow-visible print:block">
      <Sidebar />
      <MobileNav open={mobileNavOpen} onOpenChange={setMobileNavOpen} />
      <div id="app-scroll-container" className="flex h-screen flex-1 flex-col overflow-y-auto print:h-auto print:overflow-visible">
        <Topbar onMenuClick={() => setMobileNavOpen(true)} />
        <main className="flex-1 px-4 py-4 sm:px-8 sm:py-6 print:p-0" data-testid="app-main-content">
          {children}
        </main>
      </div>
    </div>
  );
}
